import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import { window } from 'browser-monads'
import Backgroundsection from '../BackgroundImage'
import Img from "gatsby-image"
import { Link } from 'gatsby'

import { makeStyles } from '@material-ui/core/styles';
import MobileAppbar from './MobileAppbar';

const useStyles = makeStyles( theme => ({
  background1: {
    height: '50px',
    backgroundRepeat: 'repeat',
    backgroundSize: '80px',
    
    '@media screen and (min-width: 599px)': {
      display: 'none'
    }
  },
  background1_2: {
    display: 'none',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto',
    
    '@media screen and (min-width: 599px)': {
      display: 'block',
      height: '80px',
    }
  },
  background2: {
    width: '100%',
    height: '70px',
    backgroundRepeat: 'repeat',
    backgroundSize: '70px 70px',
    position: 'absolute !important',
    top: 0,
    opacity: '0.8 !important',
    zIndex: 0
  },
  menuBar: {
    position: 'relative'
  },
  menuBackground: {
    height: '70px',
    backgroundImage: 'linear-gradient(to right, #af0000, #670000)'
  },
  menuList: {
    width: '100%',
    height: '70px',
    display: 'none',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    listStyle: 'none',
    margin: 0,
    position: 'absolute',
    top: 0,

    '@media screen and (min-width: 599px)': {
      display: 'flex'
    }
  },
  menuListMobile: {
    listStyle: 'none',
  },
  mobileMenuList: {
    display: 'block',
    position: 'absolute',
    top: '10px',
    right: '10px',
    '@media screen and (min-width: 599px)': {
      display: 'none'
    }
  },
  menuItem: {
    color: 'white',
    fontWeight: '600',
    padding: '5px 10px',
    margin: 0,
    cursor: 'pointer',

    '& a': {
      color: 'white',
      textDecoration: 'none'
    },
    
    "& a:hover": {
      color: '#00ff00'
    }
  },
  active: {
    color: '#00ff00 !important',
    '& a': {
      color: 'inherit !important',
    },

    '@media screen and (min-width: 599px)': {
      fontWeight: '900 !important',
      color: '#fff !important',
      borderBottom: '4px solid #00ff00'
    }
  },
  menuSubItem: {
    display: 'none',
    minWidth: '200px',
    backgroundColor: '#a12323',
    position: 'absolute',
    borderRadius: '5px',
    top: '35px',
    textAlign: 'center',
    zIndex: 2,
    '& p': {
      margin: '5px 10px',
      color: "#fff",

      "&:hover": {
        color: '#00ff00'
      }
    }
  },
  menuSubList: {
    position: 'relative',
    "&:hover": {
      "& $menuSubItem": {
        display: 'block'
      }
    }
  },
  menuItemWithdrop: {
    margin: '0'
  },
  logo: {
    minWidth: '140px',
    height: '140px',
    backgroundColor: 'white',
    borderRadius: '50%',
    margin: '85px 0 0 0',
    zIndex: 2
  },
  mobileLogo: {
    minWidth: '90px',
    height: '90px',
    backgroundColor: 'white',
    borderRadius: '50%',
    position: 'absolute !important',
    top: '10px',
    left: 'calc(50% - 45px)',
    zIndex: 2,

    '@media screen and (min-width: 599px)': {
      display: 'none !important'
    }
  },
  mobileLogo2: {
    minWidth: '90px',
    height: '90px',
    backgroundColor: 'white',
    borderRadius: '50%',
    zIndex: 2,
    marginLeft: '30px',

    '@media screen and (min-width: 599px)': {
      display: 'none !important'
    }
  }
}));

const AppBar = ({siteMetaData}) => {
  const classes = useStyles();

  const appbar = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 140 ) {
            ...GatsbyImageSharpFixed
          }
        }
      },
      mobilelogo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 90 ) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  const isBrowser = () => typeof window !== "undefined"
  const activePath = (isBrowser() && window.location.pathname) || '/'

  return (
    <div className={classes.menuBar}>
      <div className={classes.menuBackground}/>
      <Backgroundsection className={classes.background2} image="background2" />
      <nav>
        <ul className={classes.menuList}>
          <li className={`${classes.menuItem} ${(activePath === '/home' || activePath === '/home/') && classes.active}`}><Link to="/home">ಮುಖಪುಟ</Link></li>
          <li className={`${classes.menuItem} ${classes.menuSubList} ${activePath === '/aboutUs' && classes.active}`}>
            <p className={classes.menuItemWithdrop}>ನಮ್ಮ ಬಗ್ಗೆ</p>
            <div className={classes.menuSubItem}>
              <p><Link to="/aboutUs#adminMessage">ಅಧ್ಯಕ್ಷರ ಮನವಿ</Link></p>
              <p><Link to="/aboutUs#admins">ಆಡಳಿತ ಮಂಡಳಿೆ</Link></p>
              <p><Link to="/aboutUs#members">ಸದಸ್ಯರು</Link></p>
            </div>
          </li>
          <li className={`${classes.menuItem} ${activePath === '/services' && classes.active}`}><Link to="/services">ಸೇವೆಗಳು</Link></li>
          <Link to="/" label="logo"><Img fixed={appbar.logo.childImageSharp.fixed} className={classes.logo} title="Home" alt="sathyam shivam seva" /></Link>
          <li className={`${classes.menuItem} ${activePath === '/pictures' && classes.active}`}><Link to='/pictures'>ಚಿತ್ರ ಪಟಗಳು</Link></li>
          <li className={`${classes.menuItem} ${activePath === '/contactUs' && classes.active}`}><Link to='/contactUs'>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</Link></li>
          <li className={`${classes.menuItem} ${activePath === '/enquiry' && classes.active}`}><Link to='/enquiry'>ವಿಚಾರಣೆ ಪತ್ರ </Link></li>
        </ul>
        <Link to="/home"><Img fixed={appbar.mobilelogo.childImageSharp.fixed} className={classes.mobileLogo} title="Home" alt="sathyam shivam seva"/></Link>
      </nav>
      <Backgroundsection className={classes.background1} image="background1" />
      <Backgroundsection className={classes.background1_2} image="background1" />
      <div className={classes.mobileMenuList}>
        <MobileAppbar>
          <a href="/"><Img fixed={appbar.mobilelogo.childImageSharp.fixed} className={classes.mobileLogo2} title="Home" alt="sathyam shivam seva" /></a>
          <ul className={classes.menuListMobile}>
            <li className={`${classes.menuItem} ${(activePath === '/home' || activePath === '/home/') && classes.active}`}><a href="/home">ಮುಖಪುಟ</a></li>
            <li className={`${classes.menuItem} ${classes.menuSubList} ${activePath.includes('aboutUs') && classes.active}`}>
              <p className={classes.menuItemWithdrop}>ನಮ್ಮ ಬಗ್ಗೆ</p>
              <div className={classes.menuSubItem}>
                <p><a href="/aboutUs#adminMessage">ಅಧ್ಯಕ್ಷರ ಮನವಿ</a></p>
                <p><a href="/aboutUs#admins">ಆಡಳಿತ ಮಂಡಳಿೆ</a></p>
                <p><a href="/aboutUs#members">ಸದಸ್ಯರು</a></p>
              </div>
            </li>
            <li className={`${classes.menuItem} ${activePath.includes('services') && classes.active}`}><a href="/services">ಸೇವೆಗಳು</a></li>
            <li className={`${classes.menuItem} ${activePath.includes('pictures') && classes.active}`}><a href='/pictures'>ಚಿತ್ರ ಪಟಗಳು</a></li>
            <li className={`${classes.menuItem} ${activePath.includes('contactUs') && classes.active}`}><a href='/contactUs'>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</a></li>
            <li className={`${classes.menuItem} ${activePath.includes('enquiry') && classes.active}`}><a href='/enquiry'>ವಿಚಾರಣೆ ಪತ್ರ</a></li>
          </ul>
        </MobileAppbar>
      </div>
    </div>
  )
}

export default AppBar
